import { OP } from '../types';
export default {
  type: OP,
  service: 'myetherwallet.com-ws',
  url: 'wss://nodes.mewapi.io/ws/op',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
